"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  &.selected {\n    background-color: ", ";\n  }\n  transition: background-color 0.5s, transform 0.2s;\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  &:hover {\n    transform: scale(1.1);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Circle = _styledComponents.default.div.withConfig({
  displayName: "Mon317CarouselDots__Circle",
  componentId: "sc-184u0bi-0"
})(_templateObject(), _colors.KOALA, _colors.CALYPSO);

var Mon317CarouselDots = function Mon317CarouselDots(_ref) {
  var selectedIndex = _ref.selectedIndex,
      length = _ref.length,
      setSelectedIndex = _ref.setSelectedIndex,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["selectedIndex", "length", "setSelectedIndex"]);
  var circles = [];

  var _loop = function _loop(i) {
    circles.push(_react.default.createElement(Circle, {
      key: i,
      className: (0, _classNames.default)(i === selectedIndex && 'selected'),
      onClick: function onClick() {
        return setSelectedIndex(i);
      }
    }));
  };

  for (var i = 0; i < length; i++) {
    _loop(i);
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    style: {
      display: 'grid',
      gridTemplateColumns: "repeat(" + length + ", 1fr)",
      gridColumnGap: '12px'
    }
  }, rest), circles);
};

Mon317CarouselDots.propTypes = {
  selectedIndex: _propTypes.default.number.isRequired,
  setSelectedIndex: _propTypes.default.func.isRequired,
  length: _propTypes.default.number.isRequired
};
var _default = Mon317CarouselDots;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/Mon317CarouselDots.js
// module id = 885
// module chunks = 5 6